import React from 'react';
import { connect } from 'react-redux';
import { stringify } from 'query-string';

import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import SessionRequired from 'components/common/SessionRequired';

export const JanusPixel = (({ pageLoaded, pixelUrl, referer, queryParams = {} }) => {
  if (!pageLoaded) {
    return null;
  } else {
    const srcQueryParams = stringify({ referer, ...queryParams });
    return (
      <SessionRequired>
        <img alt="" className="hidden" src={`${pixelUrl}${Object.keys(queryParams).length > 0 ? `?${srcQueryParams}` : ''}`}/>
      </SessionRequired>
    );
  }
});

const ConnectedJanusPixel = connect((state, { location = window.location, link }) => {
  const { pageLoad : { loaded }, environmentConfig : { api, canonical } } = state;
  return {
    pixelUrl : `${api.mafia.url}/janus/recos/bi/ingest/pixel.png`,
    referer : `${canonical.url}${link || `${location.pathname}${location.search}`}`,
    pageLoaded : loaded
  };
})(JanusPixel);
export default withErrorBoundary('JanusPixel', ConnectedJanusPixel);
